module.exports = __webpack_public_path__ + "img/1.546c45b6.jpg";